import { SELECIONAR_POLTRONAS } from '../types'

export default function selecionarPoltronas (poltronas) {
  return {
    type: SELECIONAR_POLTRONAS,
    payload: poltronas
  }
}
